import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  column-gap: 7px;
  width: 100%;
`;
